import { Box } from '@mui/material';

type Props = {
  name: string;
  iconMap: Record<string, React.ReactNode>;
  size?: number;
  color?: string;
};

export const MapIcon =({
  name,
  iconMap,
  size = 24,
  color = '#575758',
}: Props) => {
  const normalized = name.trim().replace(/\s+/g, '');
  const icon = iconMap[normalized];
  if (!icon) return null;

  return (
    <Box sx={{ fontSize: size, color }}>{icon}</Box>
  );
}
